<template lang="pug">
section
  TopHeader
  section.section
    .container
      router-view
</template>

<script>
// @ is an alias to /src
import TopHeader from "@/components/TopHeader.vue";
import { message } from "@/helpers/messaging";

export default {
  name: "Home",

  data: () => ({
    messageSrv: message
  }),

  created() {
    this.messageSrv.messaging.onMessage(pay => console.log("Message", pay));
  },

  components: {
    TopHeader
  }
};
</script>
